import { render, staticRenderFns } from "./RhComprasSinteticoRead.vue?vue&type=template&id=d9d5f866&"
import script from "./RhComprasSinteticoRead.vue?vue&type=script&lang=js&"
export * from "./RhComprasSinteticoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports